export default __webpack_public_path__ + "static/media/devops.ed8b926e.png";